'use client';

import React from 'react';
import styled from 'styled-components';
import { Text, useUi } from '@weareconceptstudio/core';
import Button from '@/components/Button';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	text-align: center;

	.cmwp-title {
		text-align: center;
	}

	.cmwp-actions {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: var(--sp5x);
		margin-top: var(--sp7x);
	}
`;

/**
 * Same layout as the packaged CartModificationWarningPopup, but with its own
 * confirm label — the packaged component hardcodes 'account.general_actions.confirm',
 * which can't be overridden per-instance.
 */
const FulfillmentRequiredPopup = ({ onConfirm, titleKey = 'deliveryTemplate.fulfillmentSelectionRequired' }) => {
	const { closePopup } = useUi();

	return (
		<Wrapper>
			<Text
				tag='h6'
				className='cmwp-title h6 font-montserrat-arm-medium background-color'
				text={titleKey}
			/>

			<div className='cmwp-actions'>
				<Button
					btnType='cancel'
					className='cmwp-cancel'
					text='deliveryTemplate.cancel'
					onClick={closePopup}
				/>
				<Button
					btnType='full-width'
					className='cmwp-confirm'
					text='deliveryTemplate.confirmAddress'
					onClick={() => {
						closePopup();
						onConfirm?.();
					}}
				/>
			</div>
		</Wrapper>
	);
};

export default FulfillmentRequiredPopup;
